export default "__VITE_ASSET__04d77c1c__"